export const orgFiles = {
    title: "Organisation Files",
    subtitle: "Browse, edit, and share your organisation's knowledge base.",
    stats: {
      files: "Files",
      folders: "Folders",
      inFolder: "In this folder",
    },
    location: "Location",
    emptyState: {
      title: "No file selected",
      description: "Choose a file from the browser, or create a new document to get started.",
    },
    searchPlaceholder: "Search files...",
    viewModes: {
      list: "List View",
      grid: "Grid View",
      tags: "Tag View",
    },
    noFiles: "No files in this folder",
    searchNoResults: "No files match your search",
    noFolders: "No folders found",
    selectFile: "Select a file to view or edit",
    createFile: "Create File",
    createFolder: "Create Folder",
    buttons: {},
    actions: {
      link: "Link file",
    },
    moveFile: "Move File",
    deleteFile: "Delete File",
    refresh: "Refresh",
    currentLocation: "Current location:",
    newPath: "New path:",
    fullPath: "Full path:",
    selectDestination: "Select destination folder",
    fileName: "File name",
    folderName: "Folder name",
    root: "Root",
    confirmDelete: "Are you sure you want to delete {fileName}?",
    fileSaved: "File saved successfully",
    fileCreated: "File created successfully",
    folderCreated: "Folder created successfully",
    fileMoved: "File moved successfully",
    fileDeleted: "File deleted successfully",
    failedToLoad: "Failed to load folder contents",
    failedToLoadFile: "Failed to load file content",
    failedToSave: "Failed to save file",
    failedToCreate: "Failed to create {type}",
    failedToMove: "Failed to move file",
    failedToDelete: "Failed to delete file",
    failedToSearch: "Failed to search files",
    onlyMarkdownEditable: "Only markdown files can be edited",
    split: "Split",
    tags: {
      manageTags: "Manage Tags",
      currentTags: "Current Tags",
      noTags: "No tags assigned",
      addTag: "Add Tag",
      errorLoading: "Failed to load tags",
      errorSaving: "Failed to save tags"
    },
    properties: {
      title: "Properties",
      tags: "Tags",
      properties: "Properties",
      noProperties: "No properties defined"
    },
    errors: {
      loadFileContentFailed: "Failed to load file content",
      fileTypeCannotBePreviewed: "This file type cannot be previewed",
      githubAuthTitle: "Cannot reach GitHub",
      githubAuth: "GitHub rejected the organisation files token. Update the GITHUB_TOKEN secret and try again."
    }
}